import { colorsPalettes } from "@similarweb/styles";

import type { IHighChartTooltip } from "app/pages/digital-marketing/backlinks/shared/BacklinksTypes";
import { numFilter } from "app/pages/digital-marketing/backlinks/shared/BacklinksUtils";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";
import { getChartTooltipHeaders } from "app/pages/digital-marketing/backlinks/reports/overview/BacklinksOverviewConsts";
import { getBacklinksChartConfig } from "app/pages/digital-marketing/backlinks/reports/overview/components/BacklinksChart/BacklinksChartConfig";
import {
    getTooltipFormatter,
    getTooltipHeaderNewVsLost,
} from "app/pages/digital-marketing/backlinks/reports/overview/components/BacklinksChart/BacklinksChartUtils";
import type {
    GetTooltipHeader } from "app/pages/website-analysis/TrafficAndEngagement/ChartTooltips/CommonChartTooltip";
import {
    CompareModeTooltip
} from "app/pages/website-analysis/TrafficAndEngagement/ChartTooltips/CommonChartTooltip";

const getChartTooltip = (props: IHighChartTooltip) => {
    return (
        <div data-automation="new-vs-lost-tooltip">
            <CompareModeTooltip
                {...props}
                points={props.points ?? []}
                yFormatter={({ value }: { value: number }) => numFilter(Math.abs(value))}
                tableHeaders={getChartTooltipHeaders() as unknown as string[]}
                getTooltipHeader={getTooltipHeaderNewVsLost as unknown as GetTooltipHeader}
                timeGranularity={props.timeGranularity ?? GranularityNames.MONTHLY}
                x={(props.x ?? "").toString()}
            />
        </div>
    );
};

export const getNewLostChartConfig = (timeGranularity: GranularityNames) => {
    const chartParams: Highcharts.Options = {
        tooltip: {
            formatter: getTooltipFormatter(timeGranularity, getChartTooltip),
        },
        chart: {
            height: 295,
        },
        yAxis: {
            gridLineWidth: 0.5,
            showFirstLabel: true,
            showLastLabel: true,
            reversed: false,
            gridZIndex: 2,
            reversedStacks: true,
            tickPixelInterval: 50,
            labels: {
                style: {
                    textTransform: "uppercase",
                    fontSize: "11px",
                    fontFamily: "Roboto",
                    color: colorsPalettes.carbon[300],
                },
                formatter: ({ value }) => numFilter(value).toString(),
            },
        },
    };

    return getBacklinksChartConfig(timeGranularity, chartParams);
};
